import { Box, Card, Group, ScrollArea, Text } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import ExportComponent from "utiles/export";
import { formatNumber, formatStatus } from "utiles/url";

const UserDeposits = ({ ordersList, userName, totalAmount }) => {
  const headerData = [
    {
      label: "#",
      key: "index",
      sortable: false,
      searchable: false,
      width: "5%",
      render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
    },
    {
      label: "Payment Method",
      key: "payment_method",
      sortable: false,
      width: "10%",
      searchable: true,
      render: (rowData) => <b>{formatStatus(rowData?.payment_method)}</b>,
    },
    {
      label: "Transaction Reference",
      key: "txn_ref",
      sortable: false,
      width: "20%",
      searchable: true,
      render: (rowData) => <span>{rowData?.txn_ref}</span>,
    },
    {
      label: "Status",
      key: "status",
      sortable: false,
      searchable: false,
      render: (rowData) => <span>{formatStatus(rowData.status)}</span>,
    },
    {
      label: "Amount",
      key: "amount",
      sortable: false,
      searchable: false,
      render: (rowData) => <span>{formatNumber(rowData.amount)}</span>,
    },
    {
      label: "Date",
      key: "date_time",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>
          {new Date(rowData.created_at).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      ),
    },
  ];

  const { height } = useViewportSize();
  const computedTotal =
    totalAmount ??
    (ordersList || []).reduce((sum, row) => sum + (row.amount || 0), 0);

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Group position="apart" align="center" mb="sm" px="xs">
        <Box>
          {userName && (
            <Text weight={700} size="lg">
              {userName}
            </Text>
          )}
          <Text weight={600} size="md" color="dimmed">
            Transactions
          </Text>
        </Box>
        <ExportComponent
          data={ordersList || []}
          headers={headerData}
          reportTitle="User Deposit Transactions Detail"
          fileNamePrefix={`user_${userName || "detail"}_deposits`}
          userName={userName}
          totalAmount={formatNumber(computedTotal)}
        />
      </Group>

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
              paddingRight: "8px",
            }}
          >
            <Text weight={700} size="sm">
              Total Amount: {formatNumber(computedTotal)}
            </Text>
          </Box>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default UserDeposits;
